import { BehaviorSubject } from 'bog-arcade-core-ui/observer/BehaviorSubject';
import {
  BIG_WIN_STATE,
  MULTIPLIER_STATE,
  SCREEN_TRANSACTION_STATE,
  TOTAL_WIN_STATE,
} from '../../stateManagment';
import { gamePadService } from './GamePadService';
import { ballDrawer } from '../../elementDrawers/balls/BallDrawer';

class PopupService {
  constructor() {
    this._buyBonusPopupState = new BehaviorSubject(false);
    this._buyBonusClickablePopupState = new BehaviorSubject(true);
    this._buyBonusPopupConfirmState = new BehaviorSubject(false);
    this._congratulationsPopupState = new BehaviorSubject(false);
  }

  get buyBonusPopupState() {
    return this._buyBonusPopupState.getValue();
  }

  get buyBonusClickableState() {
    return this._buyBonusClickablePopupState.getValue();
  }

  get congratulationsPopupState() {
    return this._congratulationsPopupState.getValue();
  }

  disableBuyBonus() {
    this._buyBonusClickablePopupState.next(false);
  }

  enableBuyBonus() {
    this._buyBonusClickablePopupState.next(true);
  }

  get buyBonusPopupConfirmState() {
    return this._buyBonusPopupConfirmState.getValue();
  }

  subscribeBuyBonusPopupState(callBack, initialState = true) {
    return this._buyBonusPopupState.subscribe(callBack, initialState);
  }

  subscribeBuyBonusPopupConfirmState(callBack, initialState = true) {
    return this._buyBonusPopupConfirmState.subscribe(callBack, initialState);
  }

  openBuyBonusPopup() {
    this._buyBonusPopupState.next(true);
  }

  closeBuyBonusPopup() {
    this._buyBonusPopupState.next(false);
    this._buyBonusPopupConfirmState.next(false);
  }

  toggleBuyBonusPopupConfirmState() {
    const state = this._buyBonusPopupConfirmState.getValue();
    this._buyBonusPopupConfirmState.next(!state);
  }

  /** Congratulations Popup start*/
  closeCongratulationsPopup() {
    TOTAL_WIN_STATE.next(0);
    MULTIPLIER_STATE.next(1);
    ballDrawer.application.removeBonusBalls().then(() => {
      ballDrawer.application.execute();
    });
    this.enableBuyBonus();
    this._congratulationsPopupState.next(false);
  }

  openCongratulationsPopup() {
    this._congratulationsPopupState.next(true);
  }

  subscribeCongratulationsPopup(callBack, initialState = true) {
    return this._congratulationsPopupState.subscribe(callBack, initialState);
  }

  subscribeBuyBonusPopup(...args) {
    return this._buyBonusPopupState.subscribe(...args);
  }

  subscribe(callback, initialCall = false) {
    let list = [
      BIG_WIN_STATE,
      SCREEN_TRANSACTION_STATE,
    ];
    const subscribers = list.reduce((subscriber, observer) => {
      const obs = observer.subscribe((s) => {
        const state = list.map(obs => obs.getValue()).some(val => val);
        callback(state);
      }, initialCall);
      return subscriber.concat(obs);
    }, []);
    return {
      unsubscribe() {
        subscribers.forEach(sub => sub.unsubscribe());
      },
    };
  }

}

export const popupService = new PopupService();
